import { Form, Row, Col, Input, Button } from "antd";
import { MinusCircleOutlined } from "@ant-design/icons";
import { createGenericIntervention } from './helpers'
import { NodePicker } from 'Components'
import moment from 'moment';

const getRLCNode = async (lrcId) => {
  const node = await new Weaver.Query().restrict(lrcId).first();
  return node.relation('http://pms.coentunnelcompany.nl/rdl#hasAsResult').first();
}

export const AfsluitingenRecordList = ({ active, rowIndex, quarterStartDate, quarterEndDate }) => {
  const colStyle = { display: 'flex', alignItems: 'center', justifyContent: 'center' }
  const lcrQuery = new Weaver.Query()
    .lessThanOrEqualTo('http://pms.coentunnelcompany.nl/rdl#hasBeginOfLife', quarterEndDate)
    .greaterThanOrEqualTo('http://pms.coentunnelcompany.nl/rdl#hasEndOfLife', quarterStartDate)
    .hasRelationOut(
      'http://www.w3.org/1999/02/22-rdf-syntax-ns#type',
      Weaver.Node.get('http://pms.coentunnelcompany.nl/rdl#LaneClosureRequest')
    )
    .hasRelationOut('http://pms.coentunnelcompany.nl/rdl#hasAsResult',
    new Weaver.Query()
      .hasRelationOut(
        'http://www.w3.org/1999/02/22-rdf-syntax-ns#type',
        Weaver.Node.get('http://pms.coentunnelcompany.nl/rdl#RequestedLaneClosure')
      )
      .hasNoRelationOut('http://pms.coentunnelcompany.nl/rdl#isEffectOf')
    );

  const incidentQuery = new Weaver.Query()
    .hasRelationOut(
      'http://www.w3.org/1999/02/22-rdf-syntax-ns#type',
      Weaver.Node.get('http://pms.coentunnelcompany.nl/rdl#Event')
    ).hasNoRelationIn('http://pms.coentunnelcompany.nl/rdl#isEffectOf')

  return(
    <Form.List name={[rowIndex, 'records']}>
      {(fields, { add, remove }) => {
        return (
          <div key={`records-${rowIndex}`}>
            {
              fields.map((field, index) => {
                return(
                  <Form.Item
                    key={field.key}
                    style={{
                      display: 'flex',
                      alignItems: 'center'
                    }}
                  >
                    <Row gutter={8} type="flex">
                      <Col style={{ flex: 1, ...colStyle }}>
                        WNN-
                      </Col>
                      <Col style={{ flex: 6, ...colStyle}}>
                        <Form.Item
                          noStyle
                          name={[field.name, 'lcr']}
                        >
                          <NodePicker
                            showSearch
                            placeholder="Lane closure request"
                            query={lcrQuery}
                            style={{ width: '100%' }}
                            isGreedy={true}
                          />
                        </Form.Item>
                      </Col>
                      <Col style={{ flex: 1, ...colStyle }}>
                        in
                      </Col>
                      <Col style={{ flex: 6 }}>
                        <Form.Item
                          noStyle
                          name={[field.name, 'incident']}
                        >
                          <NodePicker
                            showSearch
                            placeholder="Incident"
                            suffix={(node) => ` - ${moment(node.createdAt(),"DD-MM-YYYY hh:mm")}`}
                            sorter={(list) => list.sort((a, b) => moment(b.createdAt(),"DD-MM-YYYY hh:mm:ss") - (moment(a.createdAt(),"DD-MM-YYYY hh:mm:ss")))}
                            query={incidentQuery}
                            style={{ width: '100%' }}
                            isGreedy={true}
                          />
                        </Form.Item>
                      </Col>
                      <Col style={{ flex: 1, ...colStyle }}>
                        <Form.Item noStyle>
                          <Button
                            type="text"
                            icon={<MinusCircleOutlined style={{ color: '#eb3c3c' }}/>}
                            onClick={() => remove(field.name)}
                            disabled={rowIndex !== active}
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                  </Form.Item>
                )
              })
            }
            {
              rowIndex === active && (
                <Form.Item>
                  <Button
                    onClick={() => add()}
                    type="dashed"
                    block
                  >
                    Add Record
                  </Button>
                </Form.Item>
              )
            }
          </div>
        )}
      }
    </Form.List>
  )
}

export const createAfsluitingenIntervention = async (existingData, newData) => {
  const writes = [];

  // Section records
  const addRecord = async (intervention, newRecord, writes) => {
    const record = new Weaver.Node();
    newRecord.record = record;
    const RLCNode = await getRLCNode(newRecord.lcr);
    record.relation('http://pms.coentunnelcompany.nl/rdl#newSubject').add(RLCNode);
    record.relation('http://pms.coentunnelcompany.nl/rdl#newPredicate').add(Weaver.Node.get('http://pms.coentunnelcompany.nl/rdl#isEffectOf'));
    record.relation('http://pms.coentunnelcompany.nl/rdl#newObject').add(Weaver.Node.get(newRecord.incident));
    Weaver.Functions.collectWrites(record, writes);
    intervention.relation('http://pms.coentunnelcompany.nl/rdl#appliesTo').add(record);
    Weaver.Functions.popWrites(intervention.relation('http://pms.coentunnelcompany.nl/rdl#appliesTo'), writes);
  }

  const updateRecord = async (oldRecord, newRecord, writes) => {
    const record = oldRecord.record;
    await record.load();
    if (oldRecord.lcr !== newRecord.lcr) {
      const existingRLCNode = record.relation('http://pms.coentunnelcompany.nl/rdl#newSubject').first();
      const RLCNode = await getRLCNode(newRecord.lcr);
      record.relation('http://pms.coentunnelcompany.nl/rdl#newSubject').update(existingRLCNode, RLCNode);
      Weaver.Functions.collectWrites(record, writes);
    }
    if (oldRecord.incident !== newRecord.incident) {
      const existingIncidentNode = record.relation('http://pms.coentunnelcompany.nl/rdl#newObject').first();
      const incidentNode = Weaver.Node.get(newRecord.incident);
      record.relation('http://pms.coentunnelcompany.nl/rdl#newObject').update(existingIncidentNode, incidentNode);
      Weaver.Functions.collectWrites(record, writes);
    }
  }

  return await createGenericIntervention(existingData, newData, addRecord, updateRecord, writes);
}

export const mapAfsluitingenIntervention = (intv) => ({
  intervention: intv.value,
  name: intv.children?.name[0]?.value?.value,
  reason: intv.children?.reason[0]?.value?.value,
  docid: intv.children?.docid[0]?.value?.value,
  qname: intv.children?.qid.map((n) => n?.value?.id()),
  records: intv.children?.record.map((record) => ({
    record: record.value,
    lcr: record.children?.lcr[0]?.value?.nodeId,
    incident: record.children?.incident[0]?.value?.nodeId
  }))
})

